import { inject, Injectable } from '@angular/core'
import { NgSelectConfig } from '@ng-select/ng-select'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class SelectConfig extends NgSelectConfig {
    private translateService = inject(TranslateService)
    addTagText = this.translateService.instant('common.select.addTagText')
    clearAllText = this.translateService.instant('common.select.clearAllText')
    loadingText = this.translateService.instant('common.select.loadingText')
    notFoundText = this.translateService.instant('common.select.notFoundText')
    placeholder = this.translateService.instant('common.select.placeholder')
    typeToSearchText = this.translateService.instant('common.select.typeToSearchText')
}
